import { render, staticRenderFns } from "./BraggDiffractionProViz.vue?vue&type=template&id=89054860&scoped=true"
import script from "./BraggDiffractionProViz.vue?vue&type=script&lang=js"
export * from "./BraggDiffractionProViz.vue?vue&type=script&lang=js"
import style0 from "./BraggDiffractionProViz.vue?vue&type=style&index=0&id=89054860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89054860",
  null
  
)

export default component.exports